import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { PositionedPopup } from "Components/Shared";
import { TermGroupControllerSingleton } from "Controllers";
import { FC, useState } from "react";
import { TGlobalSearchTerm, TGlobalSearchTermSearchParentGroup, TGlobalSearchTermSearchResultGroupHit } from "Types";
import { SearchTermValue } from "./SearchTermValue";

import styles from "./searchTermGroupHit.module.scss";

type TSearchTermGroupHitProps = {
    groupHit: TGlobalSearchTermSearchResultGroupHit,
    onSingleItemClick?: (text: string) => void,
    onGroupClick?: (id: string, name: string) => void
}

export const SearchTermGroupHit: FC<TSearchTermGroupHitProps> = ({ groupHit, onSingleItemClick, onGroupClick }: TSearchTermGroupHitProps) => {
    // State
    const [isPreviewOpen, setIsPreviewOpen] = useState(false);
    const [previewTerms, setPreviewTerms] = useState<TGlobalSearchTerm[]>([]);

    const getGroupPreview = async (id: string) => {
        const results = await TermGroupControllerSingleton.getPreviewAsync(id);
        setPreviewTerms(results);
        setIsPreviewOpen(true);
    };

    const clearPreview = () => {
        setIsPreviewOpen(false);
        setPreviewTerms([]);
    };

    return (
        <div>
            <SearchTermValue value={groupHit.mainTerm} onSingleItemClick={onSingleItemClick} />
            {groupHit.groups.length > 0 ?
                <div className={styles.searchTermGroupHit}>
                    <span className={styles.groupsText}>Groups</span>
                    {groupHit.groups.map((group: TGlobalSearchTermSearchParentGroup) => {
                        return (
                            <div className={styles.group} key={group.id} onClick={onGroupClick ? () => { onGroupClick(group.id, group.name); } : undefined}>
                                <span className={styles.groupTitle}>{group.name}</span>
                                <span className={styles.numberOfTerms}>{group.amountOfSearchTerms} search terms</span>
                                <span className={styles.preview} onClick={() => { getGroupPreview(group.id); }}>
                                    <FontAwesomeIcon icon={faSearch} />
                                    Preview
                                </span>
                            </div>
                        );
                    })}
                    {isPreviewOpen && previewTerms.length > 0 ?
                        <PositionedPopup onClickOutside={clearPreview}>
                            {previewTerms.map((term: TGlobalSearchTerm) => {
                                return (
                                    <div key={term.id}>
                                        <FontAwesomeIcon icon={faSearch} />
                                        <span>{term.searchTerm}</span>
                                    </div>
                                );
                            })}
                        </PositionedPopup>  
                        : null 
                    }
                </div>
                : null 
            }
        </div>
    );

};